import { render, staticRenderFns } from "./SafetyTypeBlock.vue?vue&type=template&id=20efc080&"
import script from "./SafetyTypeBlock.vue?vue&type=script&lang=js&"
export * from "./SafetyTypeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports